@use "ui/styles/fontStyles";
@use "ui/styles/sizes";

.breadcrumbMenu {
  display: flex;
  align-items: center;
  gap: sizes.$s4;

  a,
  .chevron {
    @include fontStyles.subtitle2-book;
    @include fontStyles.nonessential;
    line-height: 100%;
    &:last-child {
      @include fontStyles.foreground;
      line-height: 100%;
    }
  }
}
